import type { JSX as LocalJSX } from '@familyjs/core/components';
import React from 'react';

import { NavContext } from '../../contexts/NavContext';
import type { FamilyReactProps } from '../FamilyReactProps';
import { FmlBackButtonInner } from '../inner-proxies';

type Props = Omit<LocalJSX.FmlBackButton, 'icon'> &
  FamilyReactProps & {
    icon?:
      | {
          ios: string;
          md: string;
        }
      | string;
    ref?: React.Ref<HTMLFmlBackButtonElement>;
  };

export const FmlBackButton = /*@__PURE__*/ (() =>
  class extends React.Component<Props> {
    context!: React.ContextType<typeof NavContext>;

    clickButton = (e: React.MouseEvent) => {
      /**
       * If fml-back-button is being used inside
       * of fml-nav then we should not interact with
       * the router.
       */
      if (e.target && (e.target as HTMLElement).closest('fml-nav') !== null) {
        return;
      }

      const { defaultHref, routerAnimation } = this.props;

      if (this.context.hasFamilyRouter()) {
        e.stopPropagation();
        this.context.goBack(defaultHref, routerAnimation);
      } else if (defaultHref !== undefined) {
        window.location.href = defaultHref;
      }
    };

    render() {
      return <FmlBackButtonInner onClick={this.clickButton} {...this.props}></FmlBackButtonInner>;
    }

    static get displayName() {
      return 'FmlBackButton';
    }

    static get contextType() {
      return NavContext;
    }
  })();
